// "Staging" enabled environment

export const environment = {
    production: false,
    showReports: false,
    appConfig: 'appconfig.staging.json',
};
